import "./Channel.scss";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import { Spin } from "antd";

import partnersApi from "../../apis/Partners.api";
import ChannelCommentComponent from "../../components/channel/comment/ChannelCommentComponent";
import ProductPuchaseComponent from "../../components/channel/ProductPuchaseComponent";
import YoutubeComponent from "../../components/channel/YoutubeComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

const IngredientsId = (props) => {
	const categoryId = props.match?.params?.id;
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const [detail, setDetail] = useState({});
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [second, setSecond] = useState(0);

	const bgIngredient = ["#117FFA", "#78B8FF", "#0051AB", "#4791E3"];
	const bgFunction = ["#FF8000", "#FFB870", "#C86400", "#D98E43"];
	const queryJson = queryString.parse(
		history.location.search?.replace("?", "")
	);
	const channelId = queryJson?.id;

	useEffect(() => {
		setSecond((Math.random() * 10).toFixed() % 4);
	}, []);

	useEffect(() => {
		if (detail.id) {
			updateView();
		}
	}, [detail]);

	const updateView = async () => {
		const param = {
			category_name: "ingredient",
			updated_by: cUser?.id ?? 0,
			id: detail?.id,
			influencer_id: reduxChannel?.user_id,
		};
		await partnersApi.updatePageViewNum(param);
	};

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
		if (!channelId && reduxChannel?.influencer_id) {
			if (channelId !== reduxChannel.influencer_id) {
				history.replace(history.location.pathname + history.location.search);
			}
			// else {
			//     if (isLoading) {
			//         setIsLoading(false);
			//     }
			// }
		}
		if (reduxChannel?.user_id) {
			getCategory();
		}
	}, [reduxChannel]);

	/**
	 * 해당 카테고리 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategory = async () => {
		setIsLoading(true);
		let param = {
			categoryId: categoryId,
			categoryType: "ingredient",
			influencerId: reduxChannel?.user_id,
		};
		const res = await partnersApi.togetherCategoryDetail(param);
		if (res.code) {
			if (res.code === 200) {
				setDetail(res.result);
			} else {
				history.replace(`/404`);
			}
		}
		setIsLoading(false);
	};

	return (
		<div className="channel-home">
			<div className={`home-header`}>
				<div
					className={`home-title-div product-title`}
					style={{
						background: `${
							reduxChannel?.color_2
								? reduxChannel?.color_2
								: bgIngredient[second]
						} no-repeat right / auto 100% url("${
							process.env.REACT_APP_HOST
						}/assets/images/channel/channel-bg-0.png")`,
					}}
				>
					<div className={`max-width-apply`}>
						<h1 className={`home-title`}>{detail?.category_name}</h1>
						{reduxChannel?.user_id === 9 && (
							<p
								id={`combination-tag`}
								style={{
									whiteSpace: "pre-wrap",
									lineHeight: 1.5,
								}}
							>
								{detail?.explanation}
							</p>
						)}
					</div>
				</div>
			</div>
			<div className={`home-body`} style={{ gap: 0 }}>
				{isLoading ? (
					<Spin style={{ margin: "auto", width: "100%", paddingTop: "2em" }} />
				) : (
					<div className={`max-width-apply`}>
						<div className={`product-body`}>
							{/* 주의 사항*/}
							{detail?.caution ? (
								<div className={`product-each caution-div`}>
									<h3 className={`body-title`}>주의사항</h3>
									<p className={`caution`}>{detail.caution}</p>
								</div>
							) : (
								<></>
							)}

							{/* 관련 영상 보기 */}
							{detail?.associatedVideoList?.length ? (
								<div className={`product-each order-second-end`}>
									<h3 className={`body-title`}>관련 영상 보기</h3>
									<div className={`youtube-group`}>
										{detail.associatedVideoList?.map((item, idx) => (
											<button
												className={`youtube-each`}
												key={`관련 영상 보기 ${idx}`}
												onClick={() => {
													window.open(item?.url);
												}}
											>
												<img
													src={`/assets/images/channel/${
														item?.url.includes("instagram")
															? "instagram"
															: "youtube"
													}.png`}
													alt={`관련영상`}
													style={{
														width: "auto",
														height: "1.5em",
													}}
												/>
												<span>{item?.title}</span>
											</button>
										))}
									</div>
								</div>
							) : (
								<></>
							)}

							{/* 관련 영양제 */}
							{detail?.productList?.length ? (
								<div className={`product-each`}>
									<h3 className={`body-title`}>관련 영양제</h3>
									<div className={`product-component-each`}>
										{detail?.productList?.map((item, idx) => (
											<div
												key={`관련 성분 영양제 ${idx}`}
												style={
													item?.purchaseLinkList?.length
														? {}
														: {
																display: "none",
														  }
												}
											>
												{item?.purchaseLinkList?.length > 0 ? (
													<>
														<ProductPuchaseComponent item={item} />
													</>
												) : (
													<></>
												)}
											</div>
										))}
									</div>
									<p className={`commission-notice`}>
										제공되는 당신의 영양제, 아이허브, 쿠팡, 셀로맥스 링크는 각
										파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를
										제공받습니다. 리워드는 후원으로서 채널 운영에 활용됩니다.
										감사합니다.
										{/*제공되는 셀로맥스 스토어 링크를 통해 구매할 경우 링크 제공자에게 리워드가 지급됩니다. 리워드는 후원으로서 채널 운영에 활용됩니다. 감사합니다.*/}
									</p>
								</div>
							) : (
								<></>
							)}

							{/* 관련 고민별 */}
							{detail?.associatedFunctionList?.length ? (
								<div className={`product-each order-end`}>
									<h3 className={`body-title`}>관련 고민별</h3>
									<div className={`channel-flex-wrap`} style={{ padding: 0 }}>
										{detail?.associatedFunctionList?.map((item, idx) => (
											<button
												className={`content-button`}
												key={`function-each-more-${idx}`}
												onClick={() =>
													history.push(
														`/together/channel/functions/detail/${item?.function_id}?id=${reduxChannel?.influencer_id}`
													)
												}
											>
												<div
													className={`channel-home-button-header not-description`}
													style={{
														borderRadius: 5,
														background: `${
															reduxChannel?.color_1
																? reduxChannel?.color_1
																: bgFunction[(second + idx) % 4]
														} no-repeat right/100% url("${
															process.env.REACT_APP_HOST
														}/assets/images/channel/button-bg-${
															(second + second + idx) % 4
														}.png")`,
													}}
												>
													<p>{item?.function_name}</p>
													<img
														src={`/assets/images/channel/arrow.png`}
														alt={`화살표`}
														style={{
															height: "auto",
															width: "1em",
														}}
													/>
												</div>
												{/*<p className={`channel-home-button-header`}*/}
												{/*   style={{*/}
												{/*       background: `${bgFunction[(second + idx) % 4]} no-repeat right/100% url("${process.env.REACT_APP_HOST}/assets/images/channel/button-bg-${(idx + 1) % 4}.png")`*/}
												{/*   }}>*/}
												{/*    {item?.function_name}*/}
												{/*</p>*/}
												{/*<div className={`channel-home-button-footer`}>*/}
												{/*    <p>*/}
												{/*        {item?.tag}*/}
												{/*    </p>*/}
												{/*    <img*/}
												{/*        src={`/assets/images/channel/arrow.png`}*/}
												{/*        alt={`화살표`}*/}
												{/*        style={{*/}
												{/*            height: "auto",*/}
												{/*            width: "1.5em"*/}
												{/*        }}*/}
												{/*    />*/}
												{/*</div>*/}
											</button>
										))}
									</div>
								</div>
							) : (
								<></>
							)}

							{/* 댓글 관리 */}
							{/*{reduxChannel?.user_id === 1 && detail?.is_comment_show && (*/}
							{detail?.is_comment_show && (
								<ChannelCommentComponent detail={detail} type={"ingredient"} />
							)}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};
export default IngredientsId;
